export default 'redirect';
